/* eslint-disable require-atomic-updates */
export default {
  methods: {
    async performAction(item, action, success) {
      if (item.isLoading) {
        return
      }

      item.isLoading = true

      try {
        await action()

        await success()
      } catch (err) {
        this.$bvToast.toast(err.message, {
          title: 'Error occured',
          variant: 'danger',
          solid: true
        })
      }

      item.isLoading = false
    }
  }
}
